export default __webpack_public_path__ + "static/app-features-3--mobile-249235be5e9e3018d22b0b5fa44b1bea.webp";